import { memo } from "react";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import ProductLinkContainer from "app/pages/.shared/ProductLink/ProductLinkContainer";
import PropTypes from "prop-types";
import { productShape } from "app/utils/propTypes";

const IMG_SIZES_MOBILE = {
	small: { width: 768, height: 416 },
	medium: { width: 768, height: 416 },
};

const IMG_SIZES_DESKTOP = {
	large: { width: 502, height: 282 },
	xlarge: { width: 502, height: 282 },
};

const CLOUDINARY_OPTIONS = ["c_fill"];
const ImageWithoutCarousel = ({
	handleProductClick = () => {},
	product = {},
	openInNewTab,
	desktopImageSizes = IMG_SIZES_DESKTOP,
	mobileImageSizes = IMG_SIZES_MOBILE,
	isMobile,
}) => {
	// TODO: Remove this componet when we find a solution for the image slider on mobile due to compatibility issues and carousel swipe.	const mainPhoto = product?.photos && product.photos[0];

	const mainPhoto = product?.photos && product.photos[0];

	return (
		<ProductLinkContainer
			handleProductClick={handleProductClick}
			productUri={product.uri}
			openOnNewTab={openInNewTab}
		>
			{isMobile ? (
				<BackgroundProgressiveImg
					sizes={mobileImageSizes}
					cloudinaryOptions={CLOUDINARY_OPTIONS}
					alt={product.country}
					src={mainPhoto && mainPhoto.url}
					thumbnail={mainPhoto && mainPhoto.thumbnail}
					productUri={product?.uri}
					backgroundPosition="center"
				/>
			) : (
				<ProgressiveImg
					className="progressive-img"
					sizes={desktopImageSizes}
					alt={product.country}
					src={mainPhoto && mainPhoto.url}
					thumbnail={mainPhoto && mainPhoto.thumbnail}
					productUri={product?.uri}
				/>
			)}
		</ProductLinkContainer>
	);
};
ImageWithoutCarousel.propTypes = {
	product: productShape,
	desktopImageSizes: PropTypes.object,
	mobileImageSizes: PropTypes.object,
	openInNewTab: PropTypes.bool,
	isMobile: PropTypes.bool,
	handleProductClick: PropTypes.func,
};
export default memo(ImageWithoutCarousel);
